// The map styles object defines paths to various map styles, but with a
// relative path i.e. '/tiles/pois/...' which does not work when running the
// RouteBuilder UI or active locally.
// By checking the node env we can prepend the staging url onto the mapstyle
// which allows it to render properly in all environments.
const isDevOrStaging = process.env.NODE_ENV !== 'production';
const mapPathPrefix = isDevOrStaging ? 'https://www.staging.strava.com' : '';
const mapPathBase = `${mapPathPrefix}/tiles/pois/default-poi-style.json`;

export const MAP_STYLES = {
  standard: `${mapPathBase}?style=standard`,
  satellite: `${mapPathBase}?style=satellite`,
  hybrid: `${mapPathBase}?style=hybrid`,
  dark: `${mapPathBase}?style=dark-standard`,
  winter: `${mapPathBase}?style=winter`,
  light: `${mapPathBase}?style=light`
} as const;

export const MAP_STYLE_SELECT = Object.keys(MAP_STYLES) as Array<
  keyof typeof MAP_STYLES
>;
export type MapStyleSelectType = (typeof MAP_STYLE_SELECT)[number];

// Layer id where layers added on the client should be inserted at, this layer should be
// included in Strava map styles returned from the server.
export const LAYER_ID_TO_DRAW_ON = 'layer-to-draw-on';

export const POI_TYPES = {
  static: 'static',
  startPoint: 'startPoint',
  bikeShare: 'bikeShare'
};
